// eslint-disable-next-line jira/restricted/graphql-tag
import gql from 'graphql-tag';
import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const SINGLE_GROUP_FRAGMENT = gqlTagGira`
    fragment jiraBusinessSingleGroupFieldFragment on JiraSingleGroupPickerField {
      __typename
      id
      fieldId
      name
      selectedGroup {
        groupId
        name
      }
    }
`;

export const MULTIPLE_GROUP_FRAGMENT = gqlTagGira`
    fragment jiraBusinessMultipleGroupFieldFragment on JiraMultipleGroupPickerField {
      __typename
      id
      fieldId
      name
      selectedGroupsConnection {
        edges {
          node {
            groupId
            name
          }
        }
      }
    }
`;

export const GROUP_FRAGMENT = gql`
	${MULTIPLE_GROUP_FRAGMENT}
	${SINGLE_GROUP_FRAGMENT}
`;
